
























import { Component, Prop, Vue } from 'vue-property-decorator';
import { mapGetters } from 'vuex';

export enum DropUpColorHover {
  Primary = 'drop-up--hover-primary',
  Secondary = 'drop-up--hover-secondary',
  BlueDark = 'drop-up--hover-blue-dark',
  GreyDark = 'drop-up--hover-grey-dark',
  Gold = 'drop-up--hover-gold',
  Red = 'drop-up--hover-red',
}

@Component
export default class DropUp extends Vue {
  @Prop() private data!: any[];
  @Prop({ default: 'name' }) private labelField!: string;
  @Prop() private elementSelected!: any;
  @Prop({ default: DropUpColorHover.Secondary }) private colorHover!: DropUpColorHover;

  private isBlocked: boolean = false;
  private isBlockedLeave: boolean = false;
  private isShow: boolean = false;
  private enterPosition: boolean = true;

  private blockedDropUp() {
    this.isBlocked = !this.isBlocked;
  }

  private handleClick(element: any) {
    this.isBlocked = false;
    this.isBlockedLeave = false;
    this.mouseLeave();

    this.$emit('option-selected', element);
  }

  private mouseOverOptions() {
    if (!this.isBlocked) {
      this.isBlockedLeave = true;
    }
  }

  private mouseLeaveOptions() {
    if (!this.isBlocked) {
      this.isBlockedLeave = false;
      this.mouseLeave();
    }
  }

  private mouseOver() {
    this.isShow = true;
    this.enterPosition = false;
    (this.$refs.dropUpElement as HTMLFormElement).style.opacity = '1';
  }

  private mouseLeave() {
    setTimeout(() => {
      if (!this.isBlocked && !this.isBlockedLeave) {
        this.isShow = false;
        this.enterPosition = true;

        const dropUpElement = (this.$refs.dropUpElement as HTMLFormElement);
        if ( dropUpElement ) {
          dropUpElement.style.opacity = '0';
        }
      }
    }, 200);
  }

}
